import { PAYMENT_SETTLEMENT_HOURS } from 'config';
import React from 'react';
import { useSelector } from 'react-redux';
import {
  getActivity,
  getCartBookingType,
  getCartMultiAvailabilityList,
  getCartPriceDetails,
  getCartStatus,
} from 'state/selectors';
import { getCanEditCart } from './utils';

export const BookingHeader = ({
  title,
  onEdit,
}: {
  title: string;
  onEdit?(): void;
}) => {
  const cartStatus = useSelector(getCartStatus);
  const canEditCart = getCanEditCart(cartStatus);
  const handleClickEdit = () => {
    rudderanalytics.track(`Cart Edit clicked`, { action: title });
    onEdit();
  };
  return (
    <div className="flex justify-between mb-2">
      <h3 className="my-0 font-semibold text-md">{title}</h3>
      {onEdit && canEditCart && (
        <button className="link" onClick={handleClickEdit}>
          Edit
        </button>
      )}
    </div>
  );
};

export const AppointmentProductPriceDetails = () => {
  const priceDetails = useSelector(getCartPriceDetails);
  const bookingType = useSelector(getCartBookingType);
  const availabilityList = useSelector(getCartMultiAvailabilityList);
  const numMultiAvail =
    availabilityList?.filter((a) => a.isBookable).length ?? 0;

  if (!priceDetails) {
    return null;
  }

  return (
    <div>
      <BookingHeader title="Price details" />
      <div className="">
        {priceDetails.lineItems.map((li) => {
          return (
            <div key={li.id} className="flex justify-between space-x-2">
              <span>{li.title}</span>
              <span>{li.price.toCurrency()}</span>
            </div>
          );
        })}
        <hr />
        <div className="flex justify-between space-x-2 font-semibold">
          <span>
            {bookingType === 'multi'
              ? `Per lesson${numMultiAvail > 0 ? ` (x${numMultiAvail})` : ''}`
              : `Total (${priceDetails.currency})`}
          </span>
          <span>{priceDetails.total.toCurrency()}</span>
        </div>
        <PriceTagline />
      </div>
    </div>
  );
};

export const PriceTagline = () => {
  const activity = useSelector(getActivity);
  return (
    <div className="my-4">
      <div className="text-sm italic text-center text-gray-700">
        Total includes everything{' — '}
        {activity.instructorDescription.toLowerCase()} fees, admission to{' '}
        {activity.facilityDescription.toLowerCase()}, and any taxes. Payment
        occurs {PAYMENT_SETTLEMENT_HOURS}-hours after the{' '}
        {activity.appointmentNoun.toLowerCase()}.
      </div>
    </div>
  );
};

export const Divider = () => (
  <div className="h-1 -mx-6 bg-gray-400 md:h-px md:mx-0" />
);
